export const TABLE_RESIZING_STORAGE_KEY = 'tableResizing';
export const COOKIES_CONSENT_STORAGE_KEY = 'cookiesConsent';
export const GA_LOGIN_EVENT_STORAGE_KEY = 'gaLoginEventTime';
export const LANGUAGE_CHANGED_STORAGE_KEY = 'language-changed';
export const LAST_ENTERED_CUBICLE_TAB_STORAGE_KEY = 'lastEnteredCubicleTab';
